export const PAGE_PATHS = {
  SIGNUP: "/onboard-user",
  MOCK_CSC_AUTH_PAGE: "/mock-csc-auth",
  HANDLE_AADHAAR_AUTH_REDIRECT: "/handle-aadhaar-auth-redirect",
  ERROR: "/error",
  DEFAULT: "*",
  DEFAULT_NAVIGABLE: "/",
};
